<template>
  <div>
    <custom-text :msg="customText" :customValue="studentData" class="mt-3"></custom-text>
    <v-layout row wrap>
      <v-flex xs12 sm8 md6 lg4 xl3 pt-2 px-4 mb-5>
        <date-range-picker :date-range="dateRange" @updated="dateRangeUpdated"/>
        <span v-if="dateRangeInvalid" class="caption" style="color: red">{{$t('invalid_date_range')}}</span>
      </v-flex>
    </v-layout>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <resource-card v-for="resource in resources" :key="resource.resourceIdentifier" :resource="resource"
                       :active="active" :resourceIconMap="resourceIconMap"/>
      </v-layout>
    </v-container>
    <resource-weighting v-if="flagDisplayWeighting" :active="active"></resource-weighting>
    <resources-list :active="active" :date-range="dateRange" :studentId="studentId"></resources-list>
  </div>
</template>

<script>
  import ResourceCard from './ResourceCard'
  import ResourceWeighting from './ResourceWeighting'
  import ResourcesList from './ResourcesList'
  import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
  import DateRangePicker from '../date/DateRangePicker'
  import { SET_RESOURCES_END_DATE, SET_RESOURCES_START_DATE } from '../../store/mutation-types'
  import { GET_STUDENT_RESOURCES, GET_STUDENT_RESOURCE_WEIGHTINGS } from '../../store/action-types'
  import { HAS_FEATURE_FLAG } from '../../store/getter-types'
  import CustomText from '../help/CustomText'
  import Roles from '../../mixins/Roles'
  import moment from 'moment-es6'

  export default {
    components: {
      DateRangePicker,
      ResourceCard,
      ResourceWeighting,
      ResourcesList,
      CustomText
    },
    name: 'resources-grid',
    props: {
      active: {
        type: Boolean,
        required: true
      },
      studentId: {
        required: true
      }
    },
    mixins: [Roles],
    data () {
      return {
        loaded: false,
        dateRangeInvalid: false
      }
    },
    methods: {
      dateRangeUpdated (dateRange) {
        let diff = moment(dateRange.endDate).diff(moment(dateRange.startDate), 'days')
        if (diff >= 0) {
          this.dateRangeInvalid = false
          this.updateStart(dateRange.startDate)
          this.updateEnd(dateRange.endDate)
          this.updateResources(this.studentId)
        } else {
          this.dateRangeInvalid = true
        }
      },
      ...mapActions({
        updateResources: GET_STUDENT_RESOURCES,
        getResourceWeightings: GET_STUDENT_RESOURCE_WEIGHTINGS
      }),
      ...mapMutations({
        updateStart: SET_RESOURCES_START_DATE,
        updateEnd: SET_RESOURCES_END_DATE
      }),
      loadData () {
        this.updateResources(this.studentId)
        if (this.flagDisplayWeighting) {
          this.getResourceWeightings(this.studentId)
        }
      }
    },
    computed: {
      ...mapState({
        resources: state => state.resources.resources,
        resourceIconMap: state => state.resources.resourceIconMap,
        studentData: state => state.student,
        moduleEngagement: state => state.profile.module.engagement,
        functionResource: state => state.resources.functions.resource,
        optionEnableResourceWeighting: state => state.resources.options.enable.resourceWeighting
      }),
      ...mapGetters({
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      dateRange () {
        return {
          startDate: this.startDate,
          endDate: this.endDate
        }
      },
      startDate: {
        get () {
          return this.$store.state.resources.dateRange.startDate
        },
        set (value) {
          this.$store.commit(SET_RESOURCES_START_DATE, value)
        }
      },
      endDate: {
        get () {
          return this.$store.state.resources.dateRange.endDate
        },
        set (value) {
          this.$store.commit(SET_RESOURCES_END_DATE, value)
        }
      },
      flagDisplayWeighting () {
        return this.hasFeatureFlag(this.moduleEngagement + '.' + this.functionResource + '.' + this.optionEnableResourceWeighting)
      },
      customText () {
        let role = this.isAdmin ? 'admin' : (this.isStaff ? 'staff' : 'student')
        return 'custom-text.' + role + '.resources'
      }
    },
    watch: {
      active (value) {
        if (value) {
          this.loadData()
        }
      }
    },
    mounted () {
      if (this.active) {
        this.loadData()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/resources/ResourcesGrid.vue